import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	IAppWillMountHandler,
	FeatureExportsSymbol,
	ReducedMotionSymbol,
	ViewerModelSym,
	ViewerModel,
	Experiments,
	ExperimentsSymbol,
	SiteFeatureConfigSymbol,
	BrowserWindowSymbol,
	BrowserWindow,
} from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './symbols'
import { EnvSiteConfig } from './types'
import { ServiceBinding, ServiceFactoryOpts } from '@wix/services-manager/types'
import {
	IEnvironmentDefinition,
	IEnvironmentServiceConfig,
	IEnvironmentService,
	EnvironmentDefinition,
	EnvironmentService,
} from '@wix/environment'

const exportsName = 'env'

export const EnvFactory = withDependencies(
	[
		named(FeatureExportsSymbol, name),
		ReducedMotionSymbol,
		ViewerModelSym,
		ExperimentsSymbol,
		named(SiteFeatureConfigSymbol, name),
		BrowserWindowSymbol,
	],
	(
		envExports: IFeatureExportsStore<typeof exportsName>,
		reducedMotion: boolean,
		viewerModel: ViewerModel,
		experiments: Experiments,
		siteFeatureConfig: EnvSiteConfig,
		browserWindow: BrowserWindow
	): IAppWillMountHandler &
		ServiceBinding<
			IEnvironmentDefinition,
			(opts: ServiceFactoryOpts<IEnvironmentServiceConfig>) => IEnvironmentService
		> => {
		const { editorType, domain, previewMode } = siteFeatureConfig
		const partialConfigToExport: IEnvironmentServiceConfig = {
			editorType: editorType as IEnvironmentServiceConfig['editorType'],
			userId: viewerModel.site.userId,
			domain,
			previewMode,
			experiments,
		}

		const config: IEnvironmentServiceConfig = {
			...partialConfigToExport,
			browserWindow: browserWindow as Window,
			requestUrl: viewerModel.requestUrl,
		}

		return {
			appWillMount() {
				envExports.export({
					reducedMotion,
					...partialConfigToExport,
				})
			},
			definition: EnvironmentDefinition,
			impl: EnvironmentService,
			config,
		}
	}
)
